import { render, staticRenderFns } from "./SocialTimeline.vue?vue&type=template&id=61836c15"
import script from "./SocialTimeline.vue?vue&type=script&lang=js"
export * from "./SocialTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports